import React from "react";
import Box from "@mui/material/Box";
import TextField from "@mui/material/TextField";
import MDTypography from "components/MDTypography";

function TimeBetweenSetting({ setting, setParentState }) {
  return (
    <Box
      component="form"
      sx={{
        display: "flex",
        "& > :not(style)": { m: 1, width: "25ch" },
      }}
      noValidate
      autoComplete="off"
    >
      <MDTypography variant="p" fontWeight="medium" color="dark" mt={1}>
        {setting.en_field_label}
      </MDTypography>
      <TextField
        variant="outlined"
        value={setting.field_value.start}
        onChange={(e) => setParentState(e.target.value, "start")}
      />
      <TextField
        variant="outlined"
        value={setting.field_value.end}
        onChange={(e) => setParentState(e.target.value, "end")}
      />
    </Box>
  );
}

export default TimeBetweenSetting;
